import React, {useEffect} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";

import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {setLookOpened, setLookPageOpened} from "../../../../../actions/lookFunctions";
import {ROUTES} from "../../../../../routes";
import GroheCartHeaderCommon from "../groheCartHeaderCommon";
import GroheCartDesignRecommended from "../groheCartDesignRecommended/groheCartDesignRecommended";
import {clearCartAndStartOver} from "../../../../../actions/shoppingCartFunctions";


const GroheCartSuccess = (props) => {

  const {setLookPageOpened, setLookOpened, history, isMobile, fabricatorData, clearCartAndStartOver} = props;

  useEffect(() => {
    clearCartAndStartOver()
  }, [clearCartAndStartOver]);

  const continueShoppingCheckoutButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.cartCheckoutSuccessContinueShopping);
    setLookPageOpened("");
    setLookOpened(false);
    history.push(ROUTES.home);
  };

  const email = fabricatorData.contactEmail;
  const phone = fabricatorData.phone;

  const subTitleTranslateId = email && phone
    ? "grohe.cart.success.subTitle"
    : email && !phone
      ? "grohe.cart.success.subTitleEmailOnly"
      : phone && !email
        ? "grohe.cart.success.subTitlePhoneOnly"
        : "grohe.cart.success.subTitleNothing";

  return (
    <div className="gc">
      <div className="gc-body gc-body--success">
        <GroheCartHeaderCommon title="grohe.cart.success.title" subTitle={subTitleTranslateId} subTitleValues={{phone, email}}/>
        <div className="text-center">
          <Button className="look-button look-button--blue look-button--big look-button--large nowrap"
                  onClick={continueShoppingCheckoutButtonClick}>
            <FormattedMessage id="grohe.feature.continiueShopping"/>
          </Button>
        </div>
        {fabricatorData.isSolidSurface ? null : <GroheCartDesignRecommended/>}
        {isMobile ? <div className="gc-spacer"/> : null}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const fabricatorData = store.fabricatorState;
  return {
    isMobile,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
  setLookOpened,
  clearCartAndStartOver,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheCartSuccess)
)
